import React from 'react';
import '../../css/loading-spinner.css';

export const LoadingSpinner = () => (
  <div className="loading-spinner-container">
    <div className="spinner-border text-primary" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
);
